import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
import { isLogged } from './core/guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'marketplace',
    pathMatch: 'full',
  },
  {
    path: 'marketplace',
    loadChildren: () =>
      import('./pages/marketplace/marketplace.module').then(
        (m) => m.MarketplaceModule,
      ),
  },
  {
    path: 'inventory',
    loadChildren: () =>
      import('./pages/inventory/inventory.module').then(
        (m) => m.InventoryModule,
      ),
    canMatch: [() => isLogged()],
  },

  {
    path: 'buy-coins',
    loadChildren: () =>
      import('./pages/buy-coins/buy-coins.module').then(
        (m) => m.PaymentModule,
      ),
    canMatch: [() => isLogged()],
  },

  {
    path: '**',
    redirectTo: 'marketplace',
  },
];

const routerOptions: ExtraOptions = {
  scrollPositionRestoration: 'top',
  anchorScrolling: 'enabled',
};

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
